$(document).ready(function(){
var dropdownLinks = document.querySelectorAll(
  "a.dropdown_link--vertical.mega-menu-parent.dropdown_link"
);

dropdownLinks.forEach(function (dropdownLink) {
  dropdownLink.addEventListener("keydown", function(event) { // Listen for keydown events!
    if (event.target === dropdownLink) {
      if (event.keyCode === 32 || event.keyCode === 40) { // Check Space and Down Arrow keys
        event.preventDefault(); // Prevent the default action of space/down arrow key
        // Find the corresponding dropdown element
        var dropdown = document.querySelector(`div[data-dropdown="${dropdownLink.getAttribute("data-dropdown-rel")}"]`);
        dropdown.style.display = "block";
        dropdown.focus();
        dropdownLink.setAttribute("aria-expanded", "true");

        // Add event listener for "Esc" key to close the dropdown and return focus
        dropdown.addEventListener("keydown", function(event) {
          if (event.key === "Escape" || event.keyCode === 27) {
            event.preventDefault();
            dropdown.style.display = "none";
            dropdownLink.focus();
            dropdownLink.setAttribute("aria-expanded", "false");
          }
        });
      }
    }
  });
});
});
